const doc = [({"ko":({"adminConstantCompanyAdminUserRoleType":({"admin":"관리자", "facilityAdmin":"시설 관리자", "facilityOperator":"시설 운영자"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;